const styles = {
    mainBox: {
        margin: 1,
        backgroundColor: "white",
        borderRadius: "5px",
    },
    radioRow: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        mb: 2,
        ml: 4,
        mt: 2,
    },
    radioGroup: {
        '& .MuiFormControlLabel-root': {
            alignItems: 'center',
            mr: 4, // space between options – optional
            '& .MuiFormControlLabel-label': {
                whiteSpace: 'nowrap', // keeps label on same line as radio
            },
        },
    },
    radio: {
        color: "#0055A8",
        '&.Mui-checked': { color: "#0055A8" },
        '& .MuiSvgIcon-root': { fontSize: "20px" },
        '& .MuiSvgIcon-root path': { transform: 'scale(1)' },
    },
};

export default styles;